import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiInfo } = FiIcons;

const InfoTooltip = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div 
      className="relative inline-block ml-2 align-middle z-50"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <div className="cursor-help text-me-blue hover:text-me-orange transition-colors duration-200">
        <SafeIcon icon={FiInfo} className="w-5 h-5" />
      </div>
      
      {isVisible && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 p-3 bg-me-blue text-white text-sm rounded-lg shadow-xl z-[100]">
          {text}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 tooltip-arrow border-t-me-blue"></div>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;